import React from "react";
import classnames from "classnames";
import styles from "./Header.module.scss";
import sheredStyles from "../../Table.module.scss";
import rowStyles from "../Row/table-row.module.scss";
import { OverflowCheckDiv } from "../../../../utilsComponents/OverflowCheckDiv";
import { TuvisSkeleton } from "@whatslly/ui-components/TuvisSkeleton";
import { SvgV2 } from "@whatslly/ui-components/v2/BaseElements/SvgV2";
import { Checkbox } from "@whatslly/ui-components/v2/Checkbox";
import type { TableSort } from "../../TableTypes";

const SKELETON_HEIGHT = "19px";
export const Header: React.FC<{
  columns: { title: string; centerHeader?: boolean; keyInsideItem: string; disableSortBy?: boolean }[];
  className?: string;
  gridTemplateColumns?: string;
  tableIsOverflown: boolean;
  loading?: boolean;
  sort?: TableSort;
  onSort?: (keyInsideItem: string) => void;
  showSelectedItems?: boolean;
  onSelectAllItems?: () => void;
  allItemsSelected?: boolean;
  showSelectAllCheckbox?: boolean;
}> = ({
  columns,
  className,
  gridTemplateColumns,
  tableIsOverflown,
  loading,
  sort,
  onSort,
  showSelectedItems,
  onSelectAllItems,
  allItemsSelected,
  showSelectAllCheckbox,
}) => {
  return (
    <div
      className={classnames(sheredStyles.tableGrid, styles.tableHeader, className, { [styles.tableIsOverflown]: tableIsOverflown })}
      style={{ gridTemplateColumns: showSelectedItems ? `0.1fr ${gridTemplateColumns}` : gridTemplateColumns }}
    >
      {showSelectedItems && (
        <TuvisSkeleton height={SKELETON_HEIGHT} loading={loading}>
          <div className={rowStyles.checkboxWrapper}>
            {onSelectAllItems && showSelectAllCheckbox && (
              <Checkbox
                testId="select-all-checkbox"
                classNameChecked={rowStyles.checkboxChecked}
                className={rowStyles.checkbox}
                value={allItemsSelected || false}
                size="large"
                onChange={onSelectAllItems}
              />
            )}
          </div>
        </TuvisSkeleton>
      )}
      {columns.map((column, index) => (
        <TuvisSkeleton height={SKELETON_HEIGHT} loading={loading} key={index}>
          <div
            className={classnames(styles.headerCol, {
              [styles.centerHeader]: column.centerHeader,
              [styles.sortable]: !column.disableSortBy && sort && onSort,
            })}
            data-testid={`${column.keyInsideItem}-column-header`}
            onClick={() => !column.disableSortBy && onSort?.(column.keyInsideItem)}
          >
            <OverflowCheckDiv className={styles.ellipsis} tooltipText={column.title}>
              {column.title}
            </OverflowCheckDiv>
            {sort && !column.disableSortBy && (
              <span
                className={classnames(styles.sortArrow, {
                  [styles.active]: sort.keyInsideItem === column.keyInsideItem,
                  [styles.desc]: sort.direction === "desc",
                })}
              >
                <SvgV2 width={12} height={12} iconName="arrow_down" />
              </span>
            )}
          </div>
        </TuvisSkeleton>
      ))}
    </div>
  );
};
